// Feedback.State — the reports people sent from the app, per workspace.
//
// A report is what one signed-in person sent: its kind, their own words
// (untrusted text, shown as plain text only), the context they chose to keep
// (each item visible and removable before sending: nothing hidden), and
// whether they may be contacted about it, and whether the operator has
// handled it. Reports are kept in the order they were sent; the operator's
// list shows them newest first.
export { FEEDBACK_KINDS, findReport, initial, mkContextText, mkFeedbackText, reportsOnDay, utcDay, };
const FEEDBACK_KINDS = ["problem", "idea", "question"];
const mkFeedbackText = (s) => s;
const mkContextText = (s) => s;
const initial = { reports: [] };
const DAY_MS = 86_400_000;
// The UTC calendar day a moment falls on (days since the epoch).
const utcDay = (at) => Math.floor(at / DAY_MS);
// How many reports `reporter` sent on the UTC day of `at`. O(n) time in the
// workspace's reports, O(1) space; n grows by at most the daily ceiling per
// person per day.
const reportsOnDay = (state, reporter, at) => state.reports.filter((r) => r.reporter === reporter && utcDay(r.at) === utcDay(at)).length;
// The report with this id, if the workspace holds one. O(n) in its reports.
const findReport = (state, reportId) => state.reports.find((r) => r.id === reportId);
//# sourceMappingURL=state.js.map